import { render, staticRenderFns } from "./UserTabDetails.vue?vue&type=template&id=f3e07f24&scoped=true&"
import script from "./UserTabDetails.vue?vue&type=script&lang=ts&"
export * from "./UserTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e07f24",
  null
  
)

export default component.exports